/** @format */

export const commonEditModeModule = 'sis-components.util.edit-mode';

(function () {
    angular.module(commonEditModeModule, []).directive('ngAutofocus', focus);

    function focus() {
        return {
            link: function (scope, element, attrs) {
                scope.$watch(attrs.ngAutofocus, () => {
                    element[0].focus();
                });
            },
        };
    }
})();
